import React from 'react';
import { IconButton } from '@mui/material';
import appleIcon from '../../assets/apple.png';
import { useUserStore } from '../../stores/userStore';
import { trackExternalLinkClick } from '../../lib/gaEvents';
import { EXTERNAL_LINK_TYPE, CONTENT_TYPE } from '../../constants/gaEnums';

const AppleMusicButton = ({ url, contentId, pageType }) => {
  const user = useUserStore((state) => state.user);

  const handleClick = () => {
    trackExternalLinkClick(
      {
        linkType: EXTERNAL_LINK_TYPE.APPLE_MUSIC,
        contentType: CONTENT_TYPE.ALBUM,
        contentId,
        pageType,
      },
      user,
    );
    window.open(url, '_blank');
  };

  return (
    <IconButton
      onClick={handleClick}
      disableRipple
      sx={{
        width: { xs: 32, md: 40 },
        height: { xs: 32, md: 40 },
        backgroundColor: 'transparent',
        padding: 0,
        '&:hover': {
          backgroundColor: 'transparent',
        },
      }}
    >
      <img src={appleIcon} alt="Apple Music" style={{ width: '100%', height: '100%' }} />
    </IconButton>
  );
};

export default AppleMusicButton;
